//获取异步数据
import $axios from '../static/js/axios.js'

export default{
	//初始化
	init({ commit, state, dispatch }){
		return new Promise((resolve,reject)=>{
			const { isMobile } = state.isMobile
			if(!isMobile){
				// dispatch('getNav').then(()=>{
				// 	resolve()
				// })
				dispatch('getOrgId').then(()=>{
					dispatch('getNav').then(()=>{
						resolve()
					})
				})
			}
			
		})
	},
	
	//查询门户首页一级栏目数据
	getNav({ commit, state, dispatch }){
		return new Promise((resolve,reject)=>{
			$axios({
				url:`/jxedu/api/site/firstColumnList`,
			}).then(res=>{
				let list = res.data
				commit('changeNavList',list)
				resolve()
			})
		})
	},
	
	//获取通用院校id
	getOrgId({ commit, state, dispatch }){
		return new Promise((resolve,reject)=>{
			let domain = (document.domain == '114.132.236.184' || document.domain == 'localhost')?'www.qxcourse.com':document.domain
			$axios({
				url:`/jxedu/api/site/findOrgByDns`,
				params:{
					code:'5',
					platformUrl:domain,
					// platformUrl:'www.jxeducourse.com',
				}
			}).then(res=>{
				commit('changeOrgId',(res.data.orgId || ''))
				resolve()
			},res=>{
				resolve()
				console.log('changeOrgId---失败')
			})
		})
	},
	
}


// WEBPACK FOOTER //
// ./src/store/actions.js